export default __webpack_public_path__ + "static/media/nirvanaMob.fdf07418.PNG";